import { BASE_FONT_SIZE_PX } from '../constants/constants';

export const pxToRem = (value: string): string => {
  if (!`${value}`.endsWith('px')) {
    return `${value}`;
  }

  // this matches integers, negatives, and decimals
  const numReg = /^-?\d+\.?\d*/;
  const matched = value.match(numReg);

  if (matched === null) {
    throw new Error(
      `pxToRem: Unable to convert value to rem. Invalid value provided: ${value}`
    );
  }

  const pxValue = parseFloat(matched[0]);

  const remValue = pxValue / BASE_FONT_SIZE_PX;
  return `${remValue}rem`;
};
